import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PoplRow from "@/components/PoplRow";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="border-b-2 border-black">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
          <p className="label-mono text-[color:var(--muted-text)]">ABOUT / TWO BRANDS, ONE SHOP</p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-6 mb-8">
            <img
              src="/logos/down-to-film.png"
              alt="Down To Film Apparel"
              className="h-24 md:h-32 w-auto object-contain"
              data-testid="about-logo-dtf"
            />
            <span className="w-px h-16 md:h-20 bg-black/25" aria-hidden />
            <img
              src="/logos/sticky-chick.webp"
              alt="The Sticky Chick — Stickers & Graphics"
              className="h-24 md:h-32 w-auto object-contain"
              data-testid="about-logo-sc"
            />
          </div>
          <h1 className="font-display text-6xl md:text-8xl leading-[0.88] mt-3">
            SMALL SHOP.<br />
            <span className="text-[color:var(--primary)]">BIG STANDARDS.</span>
          </h1>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-7">
          <p className="font-body text-lg text-[color:var(--muted-text)] leading-relaxed">
            We&rsquo;re a family-run print shop that started in a garage with one heat press,
            a stack of blanks, and the belief that quality custom apparel shouldn&rsquo;t
            require a corporate account. Today we run two brands under one roof:
            <strong className="text-black"> Down To Film Apparel</strong> for direct-to-film
            (DTF) apparel and marketing print, and <strong className="text-black">The Sticky Chick</strong>
            {" "}for permanent adhesive vinyl decals and printable label sheets.
          </p>
          <p className="font-body text-lg text-[color:var(--muted-text)] leading-relaxed mt-6">
            Every job is decorated in-house with DTF transfers and heat press on quality American-made blanks —
            because we like knowing where our stuff comes from, and we bet you do too.
          </p>

          <Link to="/quote" className="btn-brutal btn-brutal-red mt-10" data-testid="about-quote-btn">
            Work With Us <ArrowUpRight size={16} />
          </Link>
        </div>
        <div className="md:col-span-5">
          <div className="brutal-card overflow-hidden hard-shadow">
            <img
              src="/media/hero.webp"
              alt="Real workshop shot — DTF transfer freshly heat-pressed onto a black tee"
              className="w-full h-[420px] object-cover"
            />
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pb-24 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { k: "HEAT PRESSES", v: "4 STATIONS" },
          { k: "AVG TURNAROUND", v: "5 DAYS" },
          { k: "REPEAT CLIENTS", v: "86%" },
        ].map((s) => (
          <div key={s.k} className="brutal-card p-8 hard-shadow-red">
            <p className="label-mono text-[color:var(--muted-text)]">{s.k}</p>
            <p className="font-display text-5xl mt-3">{s.v}</p>
          </div>
        ))}
      </section>

      <PoplRow />
    </div>
  );
}
